import "./ConfirmModal.css";
import Closeicon from "../../../images/Closeicon";

const ConfirmModal = ({ isOpen, onClose, content, onConfirm }) => {
    const handleConfirmAction = (e) => {
        onConfirm();
        onClose(e);
    };

    return (
        <div className="modal-container "    style={{display: `${isOpen  ? 'flex' : 'none' }` }} >
            <div className="modal_section modal-content">
                <button className='buttonClose' type='button' onClick={onClose} >
                    <Closeicon />
                </button>
                <p className="modal_header"> {content }</p>
                <div className=" buttons_yes_no">
                    <button className="button" onClick={handleConfirmAction}>YES</button>
                    <button className="button"  onClick={onClose}>Cancel</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;